export default __webpack_public_path__ + "static/stort-fokus-pa-populare-spelleverantorer-05636a4860812a09ec11ac17e0d59214.jpg";